<template>
  <!-- 首页精选计划 -->
  <ul class="choicenessList fvlrw">
    <li v-for="(item, index) in choicenessList" :key="index" @click="toDetail(item)">
      <img :src="item?.image[0]['imageUrl']" />
      <div class="text ellipsis">{{ item.name }}</div>
    </li>
  </ul>
  <van-divider v-if="choicenessList && choicenessList.length" dashed :style="{ color: '#999', borderColor: '#666', padding: '0 50px' }">已加载全部</van-divider>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getSelectedlist } from '@/api/home'
import { useStore } from 'vuex'
export default {
  props: [],
  setup() {
    let store = useStore()
    const state = reactive({
      domain: store.state.staticDomain,
      choicenessList: []
    })
    const router = useRouter()
    const toDetail = ({ id = '', type = '' }) => {
      if (!id) return
      let pathArr = ['', '/planDetail', '', '/tyreDetail', 'choiceness']
      let queryArr = ['', { loyaltyId: id, event: '查看计划详情' }, '', { tyreId: id, event: '查看轮胎详情' }, { id, event: '查看精选线索详情' }]
      let path = pathArr[type]
      let query = queryArr[type]
      router.push({ path, query })
    }
    onMounted(async () => {
      let parmas = {
        pageNo: '1',
        pageSize: '1000'
      }
      let { list } = await getSelectedlist(parmas)
      list.map(item => {
        if (item.type === 3) {
          item.image = [
            {
              imageUrl: `${state.domain}/mp/staticimg/selectTyre2.png`
            }
          ]
        }
        return item
      })
      state.choicenessList = list
    })
    return {
      ...toRefs(state),
      toDetail
    }
  }
}
</script>

<style lang="scss" scoped>
.choicenessList {
  ul {
    overflow: auto;
    margin-top: 6px;
  }
  li {
    width: 48%;
    margin-bottom: 10px;
    background: #fff;
  }
  img {
    width: 160px;
    height: 90px;
  }
  .text {
    width: 100%;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    color: rgb(51, 51, 51);
    text-align: center;
    background: #fff;
  }
}
</style>
